import { gsap, ScrollTrigger } from '../global/gsap';

const initEraSlider = (section) => {
    const panels = section.querySelectorAll('.js-slide');
    const navItems = section.querySelectorAll('.js-slider-nav-item');
    const navProgress = section.querySelectorAll('.js-nav-progress');

    if (panels && panels.length > 0) {
        const toggleNav = (activeIndex) => {
            navItems.forEach((item, index) => {
                item.classList.toggle('is-active', activeIndex === index);
            });
        };

        gsap.set(section, { height: `${(panels.length + 1) * 100}vh` });

        const scrollTl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top top',
                end: 'bottom bottom',
                scrub: 1,
            }
        });

        scrollTl.to(navProgress, {
            clipPath: 'polygon(100% 0, 0 0, 0 100%, 100% 100%)',
            ease: 'none'
        });

        panels.forEach((panel, index) => {
            const title = panel.querySelector('.js-era-title');
            const text = panel.querySelector('.js-era-text');
            const button = panel.querySelector('.button');

            const animEls = [text, button];

            if (index === 0) {
                gsap.set(panel, {
                    autoAlpha: 1,
                    zIndex: index,
                });
                return;
            }

            gsap.set(panel, {
                autoAlpha: 0,
                zIndex: index,
            });

            gsap.set(title, {
                clipPath: 'polygon(0 0, 0 0, 0 100%, 0% 100%)'
            });

            gsap.set(animEls, {
                autoAlpha: 0,
                yPercent: 20,
            });

            const panelTl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: `top+=${index * (100 / panels.length - 1)}% top`,
                    end: 'bottom bottom',
                    toggleActions: 'play none none reverse',
                    onEnter: () => toggleNav(index),
                    onLeaveBack: () => toggleNav(index - 1)
                },
            });

            panelTl.to(panel, {
                autoAlpha: 1,
                duration: 0.2
            });

            panelTl.to(title, {
                clipPath: 'polygon(100% 0, 0 0, 0 100%, 100% 100%)',
                duration: 0.375
            }, '-=0.1');

            panelTl.to(animEls, {
                autoAlpha: 1,
                yPercent: 0,
                duration: 0.375,
                stagger: 0.05
            }, '-=0.2');
        });
    }
};

export default initEraSlider;
